(() => {
  const initGallery = (root) => {
    if (!root || root.dataset.impactisGalleryReady === 'true') return;
    root.dataset.impactisGalleryReady = 'true';
    const panels = [...root.querySelectorAll('[data-ig-media]')];
    const thumbs = [...root.querySelectorAll('[data-ig-thumb]')];
    const show = (id) => {
      panels.forEach((panel) => { panel.hidden = panel.dataset.igMedia !== id; });
      thumbs.forEach((thumb) => {
        if (thumb.dataset.igThumb === id) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.igThumb)));
    const dialog = root.querySelector('[data-ig-dialog]');
    let lastTrigger = null;
    root.querySelectorAll('[data-ig-lightbox]').forEach((button) => button.addEventListener('click', () => {
      if (!dialog?.showModal) return;
      lastTrigger = button;
      const image = dialog.querySelector('img');
      image.src = button.dataset.src || '';
      image.alt = button.dataset.alt || '';
      dialog.showModal();
      dialog.querySelector('[data-ig-dialog-close]')?.focus();
    }));
    dialog?.querySelector('[data-ig-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', () => lastTrigger?.focus());
    thumbs.forEach((thumb, index) => thumb.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
      if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = thumbs.length - 1;
      thumbs[next]?.focus();
      thumbs[next]?.click();
    }));
  };
  const initAnnouncementAccessibility = () => {
    document.querySelectorAll('.announcement-bar__slide').forEach((slide) => {
      const message = slide.querySelector('.announcement-bar__text')?.textContent?.trim();
      const link = slide.querySelector('.announcement-bar__link');
      const repeatedLabel = link?.querySelector('.visually-hidden');
      if (!message || !link) return;
      link.setAttribute('aria-label', message);
      repeatedLabel?.setAttribute('aria-hidden', 'true');
    });
  };
  const initConditionalFields = (root = document) => {
    root.querySelectorAll('[data-ig-other-toggle]').forEach((toggle) => {
      if (toggle.dataset.impactisConditionalReady === 'true') return;
      toggle.dataset.impactisConditionalReady = 'true';
      const form = toggle.closest('form');
      const detail = form?.querySelector('[data-ig-other-detail]');
      const input = detail?.querySelector('input, textarea');
      const sync = () => {
        if (!detail || !input) return;
        detail.hidden = !toggle.checked;
        input.required = toggle.checked;
        input.setAttribute('aria-required', toggle.checked ? 'true' : 'false');
        if (!toggle.checked) input.value = '';
      };
      toggle.addEventListener('change', sync);
      sync();
    });
    root.querySelectorAll('[data-ig-other-select]').forEach((select) => {
      if (select.dataset.impactisConditionalReady === 'true') return;
      select.dataset.impactisConditionalReady = 'true';
      const form = select.closest('form');
      const detail = form?.querySelector('[data-ig-other-payment]');
      const input = detail?.querySelector('input, textarea');
      const sync = () => {
        if (!detail || !input) return;
        const selected = select.value === 'OTHER';
        detail.hidden = !selected;
        input.required = selected;
        input.setAttribute('aria-required', selected ? 'true' : 'false');
        if (!selected) input.value = '';
      };
      select.addEventListener('change', sync);
      sync();
    });
  };
  const init = () => {
    document.querySelectorAll('[data-ig-gallery]').forEach(initGallery);
    initAnnouncementAccessibility();
    initConditionalFields();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
